"use client";

import React, { useEffect, useState } from "react";
import "./ChangeEmail_Modal.css";

import { Form, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faShieldHalved,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

import Gray_Btn from "../../../../common-components/common_btn/gray_btn/Gray_Btn";
import Green_btn from "../../../../common-components/common_btn/green_btn/Green_btn";

import {
  sendChangeEmailOtp,
  verifyChangeEmail,
} from "../../../../../features/my_account/Slice";
import { RegxExpression } from "../../../../../utils/common";

const ChangeEmail_Modal = (props) => {
  const { show, onHide, onSuccess, currentEmail } = props;

  const dispatch = useDispatch();

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [newEmail, setNewEmail] = useState("");

  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    watch,
    reset,
    resetField,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: { email: "", otp: "" },
  });

  useEffect(() => {
    if (show) {
      setStep(1);
      setLoading(false);
      setNewEmail("");
      reset({ email: "", otp: "" });
    }
  }, [show, reset]);

  const getError = (payload, key) => {
    const errs = payload?.errors;
    if (errs && typeof errs === "object") {
      return errs[key] || Object.values(errs)[0];
    }
    return errs || payload?.message || "Something went wrong";
  };

  const handleSendOtp = async (data) => {
    setLoading(true);

    const res = await dispatch(
      sendChangeEmailOtp({ email: data.email.trim() }),
    );

    setLoading(false);

    if (res?.meta?.requestStatus === "fulfilled") {
      setNewEmail(data.email.trim());
      setValue("otp", "");
      setStep(2);
    } else {
      setError("email", {
        type: "manual",
        message: getError(res?.payload, "email"),
      });
    }
  };

  const handleVerify = async (data) => {
    setLoading(true);

    const res = await dispatch(
      verifyChangeEmail({
        email: newEmail,
        otp: data.otp.trim(),
      }),
    );

    setLoading(false);

    if (res?.meta?.requestStatus === "fulfilled") {
      if (onSuccess) {
        onSuccess();
      }
    } else {
      setError("otp", {
        type: "manual",
        message: getError(res?.payload, "otp"),
      });
    }
  };
  console.log(watch("otp"), "watch(otp)");

  return (
    <Modal
      className="ChangeEmail_Modal change_email_popup"
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Body>
        <button type="button" className="close_btn" onClick={onHide}>
          <FontAwesomeIcon icon={faXmark} />
        </button>

        <div className="icon_circle">
          <FontAwesomeIcon icon={step === 1 ? faEnvelope : faShieldHalved} />
        </div>

        <p className="modal_title">
          {step === 1 ? "Change Email" : "Verify OTP"}
        </p>
        <p className="modal_subtitle">
          {step === 1
            ? "Enter your new email address. We will send a 4-digit OTP to verify it."
            : `We have sent a 4-digit OTP to ${newEmail}`}
        </p>

        <div className="steps">
          <span className="step active" />
          <span className={`step ${step === 2 ? "active" : ""}`} />
        </div>

        <Form.Group className="input_group">
          {step === 1 ? (
            <React.Fragment key="email_step">
              <Form.Label>New Email ID</Form.Label>
              <Form.Control
                type="text"
                key="email_input"
                autoComplete="email"
                placeholder="Enter new email"
                {...register("email", {
                  required: "Email is required",
                  maxLength: {
                    value: 100,
                    message: "Email must not exceed 100 characters",
                  },
                  pattern: {
                    value: RegxExpression.email,
                    message: "Enter a valid email address",
                  },
                  validate: (value) =>
                    !currentEmail ||
                    value.trim().toLowerCase() !==
                      String(currentEmail).toLowerCase() ||
                    "New email must be different from your current email",
                  setValueAs: (value) => value.trim(),
                })}
                onKeyDown={(e) => {
                  if (e.key === " ") {
                    e.preventDefault(); // Block spaces
                  }
                }}
              />
              {errors?.email && (
                <sup className="text-danger">{errors?.email?.message}</sup>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment key="otp_step">
              <Form.Label>Enter OTP</Form.Label>
              <Form.Control
                key="otp_input"
                className="otp_input"
                autoComplete="one-time-code"
                type="text"
                placeholder="----"
                maxLength={4}
                inputMode="numeric"
                {...register("otp", {
                  required: "OTP is required",
                  pattern: {
                    value: /^[0-9]{4}$/,
                    message: "OTP must be 4 digits",
                  },
                })}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault(); // Block non-numeric input
                  }
                }}
              />
              <div className="otp_error_div">
                {errors?.otp && (
                  <sup className="text-danger">{errors?.otp?.message}</sup>
                )}
                <span
                  className="back_link"
                  onClick={() => {
                    setStep(1);
                    resetField("otp");
                    clearErrors();
                  }}
                >
                  Change email address
                </span>
              </div>
            </React.Fragment>
          )}
        </Form.Group>

        <div className="btn_holder">
          <Gray_Btn btnText="Cancel" onClick={onHide} />

          <Green_btn
            btnText={
              loading ? "Please wait..." : step === 1 ? "Send OTP" : "Verify"
            }
            onClick={
              loading
                ? undefined
                : handleSubmit(step === 1 ? handleSendOtp : handleVerify)
            }
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ChangeEmail_Modal;
